import dayjs, { Dayjs } from 'dayjs';

const ISO = 'YYYY-MM-DD';
const day = (d: string | Dayjs): Dayjs => dayjs(dayjs(d).format(ISO));

/** Monday-first month grid; out-of-month cells are null. */
export const buildMonthGrid = (
	viewMonth: string | Dayjs
): (string | null)[][] => {
	const first = day(viewMonth).startOf('month');
	const leading = (first.day() + 6) % 7; // 0=Mon … 6=Sun (Monday-first)
	const cells: (string | null)[] = [];
	for (let i = 0; i < leading; i++) cells.push(null);
	for (let d = 0; d < first.daysInMonth(); d++)
		cells.push(first.add(d, 'day').format(ISO));
	while (cells.length % 7 !== 0) cells.push(null);
	const weeks: (string | null)[][] = [];
	for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
	return weeks;
};

export const isSameDay = (a?: string | null, b?: string | null): boolean =>
	!!a && !!b && day(a).isSame(day(b), 'day');

/** Inclusive in [start, end] by calendar day. */
export const isWithin = (d: string, start: string, end: string): boolean => {
	const x = day(d);
	return !x.isBefore(day(start)) && !x.isAfter(day(end));
};
